import { render, staticRenderFns } from "./resPopup.vue?vue&type=template&id=89bef604&scoped=true"
import script from "./resPopup.vue?vue&type=script&lang=js"
export * from "./resPopup.vue?vue&type=script&lang=js"
import style0 from "./resPopup.vue?vue&type=style&index=0&id=89bef604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bef604",
  null
  
)

export default component.exports